/**
 * @file 留言气泡层级
 * @author quda
 */

// 自己的留言
export const SELF_MARK = 9998;

// url中指定的留言
export const ASSIGN_MARK = 9999;

// 自己新发的留言
export const NEW_SELF_MARK = 10000;

// 红包mark
export const RED_PACK_MARK = 10002;